/*
 * CheckoutStep1Page Messages
 *
 * This contains all the text for the CheckoutStep1Page container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.CheckoutStep1Page';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the CheckoutStep1Page container!',
  },
  invoiceNoteError: {
    id: `${scope}.invoiceNoteError`,
    defaultMessage: 'Không thể lưu ghi chú hóa đơn. Vui lòng thử lại.',
  },
});
